import { render, staticRenderFns } from "./ViewEvent.vue?vue&type=template&id=ee776bfc&scoped=true&"
import script from "./ViewEvent.vue?vue&type=script&lang=ts&"
export * from "./ViewEvent.vue?vue&type=script&lang=ts&"
import style0 from "./ViewEvent.vue?vue&type=style&index=0&id=ee776bfc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee776bfc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
